import { writable, type Writable } from 'svelte/store'
import type { Profile } from '$lib/types/profile'
import { trpc } from '$lib/trpc/client'

export const likes = <Writable<Array<string>>> writable([''])
export const bookmarks = <Writable<Array<string>>> writable([''])
export const profile = <Writable<Profile>>writable({} as Profile)
export const user = <Writable<string | undefined>> writable(undefined)

export async function toggleLike(likes: Array<string>, key: string): Promise<Array<string>> { 
	trpc().likes.toggle.mutate({ key })	

	if (likes.find(el => el === key)) {
		return likes.filter(el => el !== key)
	} else {
		console.log('adding like', key)
		return [...likes, key]
	}
}
	
export async function addLike(likes: Array<string>, key: string): Promise<Array<string>> {

    if (key.includes('book:')) {
		trpc().books.addLike.mutate({ bookID: key })
	} else trpc().counters.add.mutate({ counter: 'likes', key })

	return [...likes, key]
}

export async function removeLike(likes: Array<string>, key: string): Promise<Array<string>> {
	if (key.includes('book:')) trpc().books.removeLike.mutate({ bookID: key })
	else trpc().counters.delete.mutate({ counter: 'likes', key })

	return likes.filter((el) => el !== key)
}

export function isLiked(likes: Array<string>, key: string): boolean {
	return likes ? (likes.find((el) => el === key) ? true : false) : false
}

export async function addBookmark(bookmarks: Array<string>, key: string): Promise<Array<string>> {
	trpc().counters.add.mutate({ counter: 'bookmarks', key })
	return [...bookmarks, key]
}

export async function removeBookmark(
	bookmarks: Array<string>,
	key: string
): Promise<Array<string>> {
	trpc().counters.delete.mutate({ counter: 'bookmarks', key })
	return bookmarks.filter((el) => el !== key)
}

export function isBookmarked(bookmarks: Array<string>, key: string): boolean {
	if (bookmarks) return bookmarks.find((el) => el === key) ? true : false
	else return false
}
